import React from 'react';
import GlobalFonts from '@titelmedia/bricks-theme';

export const wrapRootElement = ({ element }) => (
  <>
    <GlobalFonts />
    {element}
  </>
);
